import React, { useCallback, useEffect, useState } from "react";
import { API } from "../../shared/api/Api";
import { selectUserInformations } from "../../features/authSlice";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
import { showToast } from "../../utils/utils";
import PaymentTable from "../../components/Tables/PaymentTable";
import RefundTable from "../../components/Tables/RefundTable";

const DEBOUNCE_DELAY = 700;

const RefundPage = () => {
  const [reFetchData, setReFetchData] = useState(false);
  const [refunds, setRefunds] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [loader, setLoader] = useState(true);
  const [orderBy, setOrderBy] = useState("created_at");
  const [orderDir, setOrderDir] = useState("DESC");

  const user = useSelector(selectUserInformations);
  const params = useParams();

  const fetchRefund = useCallback(async () => {
    try {
      const { data } = await axios.get(
        `${API.Refunds.app_courses_payments_refund_all}`,
        {
          params: {
            page: currentPage,
            search: debouncedSearch,
            orderBy: orderBy,
            orderDir: orderDir,
          },
          headers: { Authorization: `Bearer ${user.token}` }, // Added token
        }
      );

      if (data.status === 200 && data.errorCode === 0) {
        // Assuming similar structure
        setRefunds(data.data.items);
        setCurrentPage(data.data.current_page);
        setTotalPages(data.data.last_page);
        setReFetchData(false); // Add this line
      } else {
        showToast("Error", "Failed to fetch refunds", "error");
      }
    } catch (error) {
      showToast(
        "Error",
        error.response?.data?.message ||
          "An error occurred while fetching refunds",
        "error"
      );
    }
  }, [currentPage, debouncedSearch, user.token, orderBy, orderDir]); // Added user.token

  const handleSort = (column, direction) => {
    setOrderBy(column);
    setOrderDir(direction);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setCurrentPage(1);
    }, DEBOUNCE_DELAY);

    return () => clearTimeout(handler);
  }, [search]);

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      try {
        setRefunds([]);
        await fetchRefund();
      } catch (error) {
        showToast("Error", error.message || "An error occurred", "error");
      } finally {
        setLoader(false);
      }
    };
    fetchData();
  }, [fetchRefund, reFetchData]);


  return (
    <div className="min-h-screen p-2 sl:pt-0 sm:p-2 md:p-4 sl:p-6">
      <RefundTable
        currentPage={currentPage}
        loader={loader}
        onPageChange={setCurrentPage}
        onSearchChange={setSearch}
        refunds={refunds}
        totalPages={totalPages}
        setReFetchData={setReFetchData}
        onSort={handleSort}
        currentOrderBy={orderBy}
        currentOrderDir={orderDir}
      />
    </div>
  );
};

export default RefundPage;
